const Metas = require('./Metas')

module.exports = Metas
